import React, { memo } from 'react'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { Grid } from '@material-ui/core'

import { ALTO_ELEVADOR, LARGO_ELEVADOR, SECTORES_SIN_TORRES } from '../../../../../config/silos'
import { parseDataForCuadroDeMando } from '../../../../../models/movimiento/movimientoUtils'
import { NUCLEOS_CUADRO_DE_MANDO } from '../../../../CuadroDeMandoMovimientos/containers/constants'
import { openDialog } from '../../../../Forms/SharedComponents/containers/Dialog/actions/dialogActions'
import { updateSiloSeleccionado,
  actualizarEstadoFiltroSilos,
  resetEstadoFiltroSilos } from '../../../actions'
import GraficoSilosView from '../components/GraficoSilosView'
import InfoSilosView from '../components/InfoSilosView'
import { OperacionesEnSilo } from '../operacionesEnSilo/containers/OperacionesEnSilo'

const silosParaGrafico = createSelector(silos => silos, (silos) => parseDataForCuadroDeMando(silos))

const mapStateToProps = (state) => ({
  loading: state.movimientos.estadoSilos.loading,
  siloSeleccionado: state.movimientos.estadoSilos.siloSeleccionado,
  silos: silosParaGrafico(state.movimientos.estadoSilos.silos),
  filtrado: state.movimientos.estadoSilos.filtrado,
  cereal: state.movimientos.estadoSilos.cereal,
  variedad: state.movimientos.estadoSilos.variedad
})

export const GraficoSilos = connect(mapStateToProps, { openDialog, updateSiloSeleccionado, actualizarEstadoFiltroSilos, resetEstadoFiltroSilos })(
  memo(({ openDialog, silos, loading, updateSiloSeleccionado, actualizarEstadoFiltroSilos, resetEstadoFiltroSilos, filtrado, cereal, variedad }) => (
    <Grid container>
      <Grid item xs={10}>
        <GraficoSilosView
          silosData={silos}
          loading={loading}
          width={LARGO_ELEVADOR * 4}
          height={ALTO_ELEVADOR * 35}
          sectores={SECTORES_SIN_TORRES}
          nucleos={NUCLEOS_CUADRO_DE_MANDO}
          onClickSilo={updateSiloSeleccionado}
          cereal={cereal}
          variedad={variedad}
          filtrado={filtrado}
        />
      </Grid>
      <Grid item xs={2}>
        <InfoSilosView
          loading={loading}
          mostrarDetallesSilo={(silo) => openDialog(() => <OperacionesEnSilo silo={silo} />, 'OPERACIONES_EN_SILO', 'md')}
          // aceptar={(values) => actualizarEstadoSilos(values.cereal, values.variedad)}
          aceptar={(values) => actualizarEstadoFiltroSilos(values.cereal, values.variedad)}
          reset={() => resetEstadoFiltroSilos()}
        />
      </Grid>
    </Grid>
  ))
)
